// Tiny least-recently-used cache backed by a Map (insertion order == recency
// order, which is all a Map already gives us for free: re-inserting a key
// moves it to the end).
//
// Extracted out of useLoopPlayer.js so the eviction logic is a pure,
// unit-testable function of gets/sets rather than something only reachable
// by driving a real AudioContext + fetch.
export function createLruCache(maxEntries) {
  const map = new Map();

  return {
    get(key) {
      if (!map.has(key)) return undefined;
      const value = map.get(key);
      // Touch: move to most-recently-used (Map re-inserts at the end).
      map.delete(key);
      map.set(key, value);
      return value;
    },

    set(key, value) {
      map.delete(key);
      map.set(key, value);
      while (map.size > maxEntries) {
        // Map iteration order is insertion order, so the first key is the
        // least-recently-used one.
        const oldestKey = map.keys().next().value;
        map.delete(oldestKey);
      }
    },

    has(key) {
      return map.has(key);
    },

    clear() {
      map.clear();
    },

    get size() {
      return map.size;
    },
  };
}
